"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeDropdownAllFilteredOutBody = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var AttributeDropdownButtons_1 = require("./AttributeDropdownButtons");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var react_intl_1 = require("react-intl");
/**
 * @internal
 */
exports.AttributeDropdownAllFilteredOutBody = function (_a) {
    var isMobile = _a.isMobile, parentFilterTitles = _a.parentFilterTitles, onApplyButtonClick = _a.onApplyButtonClick, onCancelButtonClick = _a.onCancelButtonClick;
    return (react_1.default.createElement("div", { className: "gd-attribute-filter-overlay", style: { width: isMobile ? "auto" : "245px" } },
        react_1.default.createElement("div", { className: "gd-attribute-filter-dropdown-all-items-filtered s-attribute-filter-dropdown-all-items-filtered" },
            react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { showDelay: 0, hideDelay: 0 },
                react_1.default.createElement("div", { className: "gd-filtered-message" },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "attributesDropdown.allItemsFiltered" }),
                    react_1.default.createElement("span", { className: "gd-icon-circle-question" })),
                react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: "bubble-primary gd-attribute-filter-dropdown-bubble s-attribute-filter-dropdown-bubble", alignPoints: [{ align: "bc tc" }], arrowOffsets: { "bc tc": [0, 15] } },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "attributesDropdown.itemsFiltered.tooltip", values: {
                            filters: parentFilterTitles.join(", "),
                            strong: function (chunks) { return react_1.default.createElement("strong", null, chunks); },
                        } })))),
        react_1.default.createElement(AttributeDropdownButtons_1.AttributeDropdownButtons, { applyDisabled: true, onApplyButtonClicked: onApplyButtonClick, onCloseButtonClicked: onCancelButtonClick })));
};
//# sourceMappingURL=AttributeDropdownAllFilteredOutBody.js.map